// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSelect_Kratos_css-1qprcsu-option__O-eoe{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.CustomSelect_Kratos_css-1vr111p-option__8TqoD{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.CustomSelect_Kratos_css-1r4vtzz__eEWif{
    width: 100% !important;
}
.CustomSelect_Kratos_css-48ayfv__Lzk1v{
    width: 100% !important;
}

/* code added for width of dropdown */
.CustomSelect_Kratos_css-48ayfv__Lzk1v+div {
    width: 100%;
}
.CustomSelect_Kratos_css-1jllj6i-control__vzHDY{
    min-width: 95% !important;
}
.CustomSelect_Kratos_css-19t9a5b-control__ea58O{
    min-width: 95% !important;
}
.CustomSelect_Kratos_css-vb64bg-control__iQ-RS:hover{
    min-width: 95% !important;
}
.CustomSelect_Kratos_css-vb64bg-control__iQ-RS {
    min-width: 95% !important;
}
.CustomSelect_Kratos_css-6y1x9t-control__anlIc:hover {
    min-width: 95% !important;
}
.CustomSelect_Kratos_css-6y1x9t-control__anlIc {
    min-width: 95% !important;
}
/* code added for width of dropdown */

input{
    height: inherit
}

.CustomSelect_Kratos_react-select__option__G6gok{
    font-size: 80% !important;
}

.CustomSelect_Kratos_react-select__option1__RptgR{
    font-size: 100% !important;
}

.CustomSelect_Kratos_react-select__menu-list__LfkAt{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}

.CustomSelect_Kratos_kratos_filtr_btn__ddj\\+w{
    position: relative;
    top: 10px;
}
.CustomSelect_Kratos_font-kratos-head__A\\+bN3 {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
}
.CustomSelect_Kratos_font-kratos-head_a__vHvuO {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
    text-align: left;
}
.CustomSelect_Kratos_font-kratos-head_pg__p9aoP{
    font-size: 1.25rem !important;
    color: #000;
    font-weight: 600;
}
.CustomSelect_Kratos_filter_kratos_icon__2PG1R {
    background: #fff !important;
    color: #83A4CF !important;
    padding: 0px 9px;
    font-size: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/Charginganalysis_Kratos/CustomSelect_Kratos.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA,qCAAqC;;AAErC;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".css-1qprcsu-option{\n    text-align: left;\n    min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1vr111p-option{\n    text-align: left;\n    min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1r4vtzz{\n    width: 100% !important;\n}\n.css-48ayfv{\n    width: 100% !important;\n}\n\n/* code added for width of dropdown */\n.css-48ayfv+div {\n    width: 100%;\n}\n.css-1jllj6i-control{\n    min-width: 95% !important;\n}\n.css-19t9a5b-control{\n    min-width: 95% !important;\n}\n.css-vb64bg-control:hover{\n    min-width: 95% !important;\n}\n.css-vb64bg-control {\n    min-width: 95% !important;\n}\n.css-6y1x9t-control:hover {\n    min-width: 95% !important;\n}\n.css-6y1x9t-control {\n    min-width: 95% !important;\n}\n/* code added for width of dropdown */\n\ninput{\n    height: inherit\n}\n\n.react-select__option{\n    font-size: 80% !important;\n}\n\n.react-select__option1{\n    font-size: 100% !important;\n}\n\n.react-select__menu-list{\n    max-height: 150px !important;\n    -webkit-overflow-scrolling:auto !important;\n}\n\n.kratos_filtr_btn{\n    position: relative;\n    top: 10px;\n}\n.font-kratos-head {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n}\n.font-kratos-head_a {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n    text-align: left;\n}\n.font-kratos-head_pg{\n    font-size: 1.25rem !important;\n    color: #000;\n    font-weight: 600;\n}\n.filter_kratos_icon {\n    background: #fff !important;\n    color: #83A4CF !important;\n    padding: 0px 9px;\n    font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"css-1qprcsu-option": `CustomSelect_Kratos_css-1qprcsu-option__O-eoe`,
	"css-1vr111p-option": `CustomSelect_Kratos_css-1vr111p-option__8TqoD`,
	"css-1r4vtzz": `CustomSelect_Kratos_css-1r4vtzz__eEWif`,
	"css-48ayfv": `CustomSelect_Kratos_css-48ayfv__Lzk1v`,
	"css-1jllj6i-control": `CustomSelect_Kratos_css-1jllj6i-control__vzHDY`,
	"css-19t9a5b-control": `CustomSelect_Kratos_css-19t9a5b-control__ea58O`,
	"css-vb64bg-control": `CustomSelect_Kratos_css-vb64bg-control__iQ-RS`,
	"css-6y1x9t-control": `CustomSelect_Kratos_css-6y1x9t-control__anlIc`,
	"react-select__option": `CustomSelect_Kratos_react-select__option__G6gok`,
	"react-select__option1": `CustomSelect_Kratos_react-select__option1__RptgR`,
	"react-select__menu-list": `CustomSelect_Kratos_react-select__menu-list__LfkAt`,
	"kratos_filtr_btn": `CustomSelect_Kratos_kratos_filtr_btn__ddj+w`,
	"font-kratos-head": `CustomSelect_Kratos_font-kratos-head__A+bN3`,
	"font-kratos-head_a": `CustomSelect_Kratos_font-kratos-head_a__vHvuO`,
	"font-kratos-head_pg": `CustomSelect_Kratos_font-kratos-head_pg__p9aoP`,
	"filter_kratos_icon": `CustomSelect_Kratos_filter_kratos_icon__2PG1R`
};
export default ___CSS_LOADER_EXPORT___;
